export var AircraftTag;
(function (AircraftTag) {
    AircraftTag["complex"] = "complex";
    AircraftTag["multiEngine"] = "me";
    AircraftTag["multiPilot"] = "mcc";
    AircraftTag["mutiPilotCat"] = "mcc_cat";
    AircraftTag["opsAto"] = "ops_ato";
    AircraftTag["opsCat"] = "ops_cat";
})(AircraftTag || (AircraftTag = {}));
//# sourceMappingURL=AircraftTag.js.map